import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import ABTestingTableCell from "../../Components/Table/ABTestingTableCell";
import SortableTable from "../../Components/Table/SortableTable";
import { TableColumnTypes } from "../../Enums/TableColumnTypes";
import { useGetABTestClientsQuery } from "../../Queries/ABTestQueries";
import { ITableColumn } from "../../Types/TableColumn";

const columns: ITableColumn[] = [
  { label: "Name", propName: "name", type: TableColumnTypes.Text },
  { label: "Hostname", propName: "hostname", type: TableColumnTypes.Text },
  { label: "View Tests", propName: "", type: TableColumnTypes.Actions },
];

export default function ABTestingPage() {
  const { data, isLoading } = useGetABTestClientsQuery();
  return (
    <div className="page-container">
      <Breadcrumb />
      <h1 className="page-title">A/B Testing</h1>
      <SortableTable
        columns={columns}
        tableData={data as any}
        rowComponent={ABTestingTableCell}
        loading={isLoading}
        defaultSortIndex={0}
        hideSearch={undefined}
        setTableData={undefined}
        reverse={undefined}
        pagination={undefined}
        totalItemCount={undefined}
      />
    </div>
  );
}
